import { camelObjectToSnakeObject, filterValueToQuery } from '@/api';

export default function product(axios: any) {
  interface ProductInput {
    name?: string;
    redirect_url?: string;
    image?: string;
    description?: string;
    store_id?: number;
    active?: boolean;
    favorite?: boolean;
    order?: number;
    price?: number;
  }

  async function newProduct(payload: ProductInput) {
    const response = await axios.post('/store-product', camelObjectToSnakeObject(payload));
    try {
      if (response.status === 201) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/product] newProduct Error', e);
    }
    return null;
  }

  async function updateProduct(id: any, payload: ProductInput) {
    try {
      const response = await axios.put(`/store-product/${id}`, camelObjectToSnakeObject(payload));
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/product] updateStore Error', e);
    }
    return null;
  }

  async function getProducts(store: any) {
    try {
      const response = await axios.get(`/store-product?withDeactive=true${filterValueToQuery(store)}`);
      if (response?.status === 200) {
        return response;
      }
    } catch (e) {
      console.error('[api/product] getProducts Error', e);
    }
    return null;
  }

  async function getProduct(store: any, id: number) {
    try {
      const response = await axios.get(`/store-product/${id}`);
      if (response?.status === 200) {
        return response;
      }
    } catch (e) {
      console.error('[api/product] getProduct Error', e);
    }
    return null;
  }

  async function deleteProduct(store: any, id: number) {
    try {
      const response = await axios.delete(`/store-product/${id}`);
      if (response?.status === 200) {
        return response;
      }
    } catch (e) {
      console.error('[api/product] deleteProduct Error', e);
    }
    return null;
  }

  async function deleteProductImage(id: number) {
    try {
      const response = await axios.delete(`/store-product/${id}/image`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/product] deleteProductImage Error', e);
    }
    return null;
  }

  return {
    newProduct,
    getProducts,
    getProduct,
    updateProduct,
    deleteProduct,
    deleteProductImage,
  };
}
